'use client';

import dayjs from 'dayjs';
import { Suspense } from 'react';
import { Box } from '@wishket/design-system';

import { useTodayGrassQuery } from './models';

import { GrassTile } from '@/features/NewLanding';

const TodayGrassTileBody = () => {
  const today = dayjs().format('YYYY-MM-DD');
  const {
    data: { score, colorLevel },
  } = useTodayGrassQuery(today);

  return <GrassTile date={today} score={score} colorLevel={colorLevel} />;
};

const TodayGrassTile = () => {
  return (
    <Suspense
      fallback={<Box className={'size-2.5 rounded-sm bg-w-bluegray-50'} />}
    >
      <TodayGrassTileBody />
    </Suspense>
  );
};

export default TodayGrassTile;
